import {createSelector} from '@ngrx/store';
import { getMultipleOrderModalState } from '../reducers';

export const selectExperiencesState = createSelector(getMultipleOrderModalState, state => state && state.experiences);

export const selectExperiences = createSelector(selectExperiencesState, (state) => state && state.payload);


export const selectAllExperiencesIds = createSelector(selectExperiences, ({ ids }) => ids);

export const selectAllExperiences = createSelector(
  selectAllExperiencesIds,
  selectExperiences,
  (ids, state) => {
    const _ids: any[] = ids;
    const _entities: any = state.entities;
    return _ids.map(id => _entities[id]);
  },
);
